import { getFlag } from "@/config/rdoFlags";
import { PhotosModule } from "@/components/rdo/modules/PhotosModule";
import { LegacyPhotosSection } from "@/components/rdo/legacy/LegacyPhotosSection";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";
import type { RDO } from "@/domain/rdo/schema";

export function PhotosForRDO({
  legacyValue,
  onLegacyChange,
  mode
}: {
  legacyValue: any;                 // shape atual usado em RDO.tsx (fotos)
  onLegacyChange: (v: any) => void; // setter do RDO.tsx
  mode: "edit" | "view";
}) {
  if (!getFlag("useNewPhotosInRDO")) {
    // Render legado de Fotos (manter como está)
    return <LegacyPhotosSection value={legacyValue} onChange={onLegacyChange} mode={mode} />;
  }

  // Se a flag estiver ligada, usar o novo módulo unificado
  
  // Criar objeto legacy completo para normalização (tipo correto)
  const legacyRDO: any = {
    obraId: "",
    date: "",
    status: "draft",
    workforce: [],
    equipment: [],
    materials: { received: [], used: [] },
    activities: [],
    photos: legacyValue || [],
    occurrences: [],
    comments: [],
    videos: [],
    attachments: []
  };
  
  // 1) Converte do legado -> RDO (somente photos)
  const rdo: RDO = normalizeFromRDOPAGE(legacyRDO);

  // 2) Renderiza o módulo novo com a UX do Preenchendo
  return (
    <PhotosModule
      value={rdo.photos}
      mode={mode === "edit" ? "edit" : "view"}
      onChange={(photos) => {
        // 3) Converte de volta p/ o payload legado
        const payload = toRDOPAGEPayload({ ...rdo, photos });
        onLegacyChange(payload.photos);
      }}
    />
  );
}